import { computed } from 'vue'

export default function useContainerSize() {
	const getClassByModule = (module, type_slug) => {
		if (module === 'live_class') return liveClass(type_slug)
		else if (module === 'course') return course(type_slug)
	}

	return getClassByModule
}

const course = (type_slug) => {
	const containerSize = () => {
		const players = [
			'audio',
			'flash',
			'html',
			'pdf',
			'ppt',
			'scorm',
			'linkedin_slideshare',
			'video',
			'vimeo',
			'youtube',
		]
		const tests = [
			'block_test',
			'conventional_test',
			'restart_test',
			'unevaluated_quiz',
			'evaluated_quiz',
			'block_general_test',
			'restart_general_test',
			'reaction_evaluation',
		]
		const games = [
			'drag_and_drop',
			'drag_the_words',
			'find_the_words',
			'fill_in_the_blanks',
			'flashcards',
			'true_or_false',
			'enigma',
		]

		if (players.includes(type_slug)) return 'container-activity'
		else if (tests.includes(type_slug)) return 'container-test'
		else if (games.includes(type_slug)) return 'container-game'
	}

	return containerSize(type_slug)
}

const liveClass = (type_slug) => {
	const containerSize = () => {
		const players = ['live_class_opened', 'live_class_closed', 'live_class']
		const tests = [
			'block_test',
			'conventional_test',
			'restart_test',
			'unevaluated_quiz',
			'evaluated_quiz',
			'block_general_test',
			'restart_general_test',
			'reaction_evaluation',
		]

		if (players.includes(type_slug)) return 'container-activity'
		else if (tests.includes(type_slug)) return 'container-test'
	}

	return containerSize(type_slug)
}
